module.exports = __webpack_public_path__ + "static/media/ST.4aa93f40.svg";